import { ControlledRadioCardGroup } from '@if/mui'
import { Chip } from '@mui/material'
import { EPromotionMode } from '@src/data/types/Constants'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import type { MerchantPromotionFormValues } from './tabs/MerchantPromotionTab'

interface Props {
  control: Control<MerchantPromotionFormValues>
  name: 'promotionMode'
  onChange?: (value: EPromotionMode) => void
}

/**
 * The mutually-exclusive Preconfigured / Custom promotion toggle. Bound to a form field so a
 * mode change marks the promotion tab dirty (driving the MultiFormTabs Save/dirty-guard).
 */
const PromotionModeSelector = ({ control, name, onChange }: Props) => {
  const { t } = useTranslation()

  return (
    <ControlledRadioCardGroup
      control={control}
      name={name}
      onChange={onChange}
      label={
        <>
          {t('merchant.promotionMode.title')}
          {/* span so the chip nests validly inside the label typography */}
          <Chip component="span" label={t('merchant.promotionMode.mutuallyExclusive')} size="small" sx={{ ml: 1 }} />
        </>
      }
      options={[
        {
          value: EPromotionMode.Preconfigured,
          title: t('merchant.promotionMode.preconfigured.title'),
          description: t('merchant.promotionMode.preconfigured.description'),
        },
        {
          value: EPromotionMode.Custom,
          title: t('merchant.promotionMode.custom.title'),
          description: t('merchant.promotionMode.custom.description'),
        },
      ]}
    />
  )
}

export default PromotionModeSelector
